/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import { fromLinkpageApi } from 'app/utility/LinkpageSettings.js';

// Keyed by social id. A record's identity only changes when its settings do,
// which is what the settings screen re-syncs its draft on.
export const linkpages = (state = defaultState.linkpages, action) => {
    if (action.status !== constants.STATE_SUCCESS) {
        return state;
    }

    switch (action.type) {
        case constants.LINKPAGE_SETTINGS_LIST:
            return {...state, [action.id]: fromLinkpageApi(action.payload)};

        // The endpoint echoes only what it saved (settings_api returns just the field it
        // handled), so what was sent is merged in first and the echo, if any, wins.
        case constants.LINKPAGE_SETTINGS_UPDATE:
            return {
                ...state,
                [action.id]: {...state[action.id], ...fromLinkpageApi(action.sent), ...fromLinkpageApi(action.payload)}
            };

        default:
            return state;
    }
};
